import { useLocation, useNavigate } from "react-router-dom";

export function useSafeNavigate() {
  const nav = useNavigate();
  const { pathname, search } = useLocation();
  
  return (to?: string, opts: { replace?: boolean } = { replace: true }) => {
    if (!to) return;                           // guard undefined
    const here = `${pathname}${search}`;
    if (to === here) return;                   // guard same URL
    nav(to, opts);
  };
}
